module.exports = __webpack_public_path__ + "static/media/6222.4526c744.jpg";